import { Link } from '@inertiajs/react'
import GoogleMap from '../../components/GoogleMap'

export default function Index({ offers, activeQueueOfferIds = [] }) {
  const typeColors = {
    gaming: 'bg-purple-100 text-purple-800 border-purple-300',
    dining: 'bg-orange-100 text-orange-800 border-orange-300',
    spa: 'bg-blue-100 text-blue-800 border-blue-300',
    entertainment: 'bg-green-100 text-green-800 border-green-300'
  }

  const queuedSet = new Set(activeQueueOfferIds)
  const toNumber = (value) => {
    const parsed = typeof value === 'number' ? value : Number.parseFloat(value)
    return Number.isFinite(parsed) ? parsed : null
  }
  const offerPoints = offers
    .map((offer) => {
      const lat = toNumber(offer.lat)
      const lng = toNumber(offer.lng)
      if (lat === null || lng === null) return null
      return {
        id: offer.id,
        title: offer.offer_name,
        lat,
        lng,
        infoHtml: `<div><strong>${offer.offer_name}</strong><br/>${offer.brand || ''}</div>`,
      }
    })
    .filter(Boolean)

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
        <h1 className="text-5xl font-bold text-gray-900">
          Available Offers
        </h1>
        <div className="flex gap-3">
          <Link
            href="/"
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg"
          >
            Offers
          </Link>
          <Link
            href="/queues"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg"
          >
            Active Queues
          </Link>
          <Link
            href="/admin/queue_monitor"
            className="bg-gray-800 hover:bg-gray-900 text-white font-semibold py-2 px-4 rounded-lg"
          >
            Queue Monitor
          </Link>
        </div>
      </div>
      
      {!offers || offers.length === 0 ? (
        <div className="flex items-center justify-center py-20">
          <p className="text-3xl text-gray-400">No offers available yet</p>
        </div>
      ) : (
        <div className="space-y-8">
          <div className="bg-white rounded-xl shadow p-4">
            <GoogleMap
              points={offerPoints}
              className="h-80 w-full rounded-lg"
            />
          </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {offers.map(offer => (
            <Link 
              key={offer.id} 
              href={`/offers/${offer.id}`}
              className="bg-white p-8 rounded-xl shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-2 cursor-pointer"
            >
              {queuedSet.has(offer.id) && (
                <span className="inline-block mb-3 px-3 py-1 rounded-full text-xs font-bold bg-green-100 text-green-800 border border-green-300">
                  In Queue
                </span>
              )}
              {offer.offer_marker_image_addr && (
                <img src={offer.offer_marker_image_addr} alt={offer.offer_name} className="w-full h-48 object-cover rounded-lg mb-4" />
              )}
              <h2 className="text-3xl font-bold mb-4 text-gray-900">{offer.offer_name}</h2>
              <p className="text-lg text-gray-600 mb-6 line-clamp-2">{offer.description}</p>
              <div className="flex justify-between items-center">
                <span className={`px-3 py-1 rounded-full text-sm font-semibold border ${typeColors[offer.offer_type] || 'bg-gray-100 text-gray-800 border-gray-300'}`}>
                  {offer.offer_type}
                </span>
                <span className="text-sm text-gray-500">{offer.brand}</span>
              </div>
            </Link>
          ))}
        </div>
        </div>
      )}
    </div>
  )
}
